import {Card, CardBody, Spinner, Table, TableCaption, TableContainer, Tbody, Thead, Checkbox, Stack, Tr, Th } from '@chakra-ui/react'
import { ItemsCountedTableRow } from './ItemsCountedTableRow'
import Pagination from 'components/Pagination/Pagination'
import { useState, useContext, useMemo, useRef, useEffect, useCallback } from 'react'
import { Captions } from 'components/Counting/Captions'
import { CountingTabsContext } from 'components/Counting/CountingTabs/CountingTabs'
import {useItemsCounted} from 'hooks/useItems/useItemsCounted'
import {ItemsCountedFilters} from './ItemsCountedFilters/ItemsCountedFilters'
import {HeaderSortable} from 'components/Inputs/HeaderSortable'

export const ItemsCounted = (props) => {
	const { countingId, refreshCounting } = props
	const {itemsCounted, getItemsCounted, toggleSortOrder, sortConfig, loading, filters}
		= useItemsCounted({counting_id: countingId})


	const [currentPage, setCurrentPage] = useState(1)
	const { counting } = useContext(CountingTabsContext)


    const handlePageChange = (selectedPage) => {
        getItemsCounted(selectedPage)
        setCurrentPage(selectedPage)
    }

    const refreshTable = () => {
        getItemsCounted({ page: currentPage })
        refreshCounting()
    }

    const isShopHasCategoryGroups = useMemo(() => {
        return itemsCounted?.rows && Object.values(itemsCounted.rows).some(row => row.category_row?.group)
    }, [itemsCounted?.rows])

    const formFiltersRef = useRef({})
    const handleFilterChange = useCallback((newFilters) => {
        formFiltersRef.current = newFilters
        getItemsCounted({...newFilters, row_name_exact_match: undefined})
    }, [getItemsCounted])

    const handleRowClick = (rowName) => {
        document.activeElement?.blur() //input Row blur not in focus//
        getItemsCounted ({row_name: rowName, row_name_exact_match: true})
    }

    const cardRef = useRef(null)
    useEffect(() => {
		const handleOutsideClick = (event) => {
			if (filters.row_name_exact_match && cardRef.current && !cardRef.current.contains(event.target)) {
				getItemsCounted({ row_name: formFiltersRef.current.row_name, row_name_exact_match: undefined })
			}
		}
            document.addEventListener('mousedown', handleOutsideClick)
            return () => document.removeEventListener('mousedown', handleOutsideClick)
        }, [filters.row_name_exact_match, getItemsCounted])

	return (
		<Card >
			<CardBody>

			<TableContainer>
            <Table>
                <TableCaption placement={'top'}>
                    <Captions
                        total={itemsCounted.total}
                        totalAmount={itemsCounted.total_amount}
                        totalRows={itemsCounted.total_rows}
                        countingId={countingId}
                        counting={counting}
                        group_items={filters.group_items}
                    />
					<Stack direction='row' spacing={4}>
						<Checkbox onChange={(e) => getItemsCounted({group_items: e.target.checked})}>Grouped Items</Checkbox>
					</Stack>
                </TableCaption>
                <Thead>
                    {!filters.group_items && 
                        <ItemsCountedFilters 
                            countingId={countingId} 
                            getItemsCounted={handleFilterChange}
                            counting={counting}
                        />
                    }
                    <Tr>
                        <Th>UPC</Th>
                        <Th>MKT</Th>
                        <Th>
                            <HeaderSortable fieldName='amount' title='Amount' toggleSortOrder={toggleSortOrder} sortConfig={sortConfig} />
                        </Th>
                        <Th>Description</Th>
                        {!filters.group_items && <Th><HeaderSortable fieldName='row_name' title='Row' toggleSortOrder={toggleSortOrder} sortConfig={sortConfig} /></Th>}
                        {!filters.group_items && <Th><HeaderSortable fieldName='category' title='Category' toggleSortOrder={toggleSortOrder} sortConfig={sortConfig} /></Th>}
                        {!filters.group_items && isShopHasCategoryGroups && <Th>Category Group</Th>}
                        { counting.settings?.customRowNames && <Th>Custom Row Name</Th>}
                        
                        <Th>
                            <HeaderSortable fieldName='mkt_1_length' title='Length' toggleSortOrder={toggleSortOrder} sortConfig={sortConfig} />
                        </Th>
                        {!filters.group_items && <>
                            <Th><HeaderSortable fieldName='scanned_at' title='Time' toggleSortOrder={toggleSortOrder} sortConfig={sortConfig} /></Th>
                            <Th>Device</Th>
                            <Th>Name</Th>
                            <Th>Invalid</Th>
                            <Th>Manual</Th>
                        </>}
                    </Tr>
                </Thead>
            
                <Tbody ref={cardRef}>
                    { itemsCounted.data && ( 
                        itemsCounted.data.map(item => (
                            <ItemsCountedTableRow
                                key={item._id}
                                item={item}
                                category={itemsCounted.rows[item.row_name]?.category_row?.name}
                                categoryGroup={itemsCounted.rows[item.row_name]?.category_row?.group}
                                customRowName={itemsCounted.rows[item.row_name]?.custom_row_name}
                                refreshTable={refreshTable}
                                refreshCounting={refreshCounting}
                                counting={counting}
                                group_items={filters.group_items}
                                isShopHasCategoryGroups={isShopHasCategoryGroups}
                                onRowClick = {handleRowClick}
                            />
                        )))}
                </Tbody>
            
            </Table> 
            {!loading  || <Spinner /> } <Pagination lastPage={itemsCounted.last_page ?? 1} getData={handlePageChange} />
        </TableContainer>
				{/* <ItemsCountedTable
					itemsCounted={itemsCounted}
					getItemsCounted={getItemsCounted}
					toggleSortOrder={toggleSortOrder}
					sortConfig={sortConfig}
					loading={loading}
					refreshCounting={refreshCounting}
					countingId={countingId}
					counting={counting}
				/> */}
			</CardBody>
		</Card>
	)
}
